import { memo, useCallback } from "react";
import { TransactionType } from "../../../../proto/generated/order";
import { useStyles } from "./styles";
import { Box } from "@mui/material";

export type TransactionTypeCellProps = {
    editable?: boolean,
    disabled?: boolean,
    transactionType: TransactionType,
    onChange: (transactionType: TransactionType) => void
}

const TransactionTypeCell: React.FC<TransactionTypeCellProps> = ({transactionType, editable = true, disabled, onChange}) => {

    const {classes, cx} = useStyles();

    const handleChange = useCallback(() => {
        onChange(transactionType === TransactionType.BUY ? TransactionType.SELL : TransactionType.BUY)
    }, [transactionType, onChange])
    return  <Box justifyContent="center" display="flex">
                <button data-event={'B/S Changed'}
                    data-event-source={'Trade'}
                    disabled={disabled || !editable}
                    onClick={handleChange}
                    className={cx(classes.transactionTypeButton, {
                        [classes.sellTransaction]: transactionType === TransactionType.SELL,
                        [classes.buyTransaction]: transactionType === TransactionType.BUY,
                        [classes.nonEditable]: !editable
                    })}>
                    {transactionType === TransactionType.BUY ? "B" : "S"}
                </button>
            </Box>;
}

export default memo(TransactionTypeCell);